import { startUpgradeProcess } from '@va/dashboard/actions/app';
import { CloseIconWithoutCircle, PlayIconUnfilled } from '@va/icons';
import { Button, ButtonShapes, Paragraph } from '@va/ui/design-system';
import { FC } from 'react';
import { useDispatch } from 'react-redux';

export const UpgradeTooltipContent: FC<{
  onClose: () => void;
  title: string;
  description: string;
  buttonText: string;
}> = ({ onClose, title, description, buttonText }) => {
  const dispatch = useDispatch();

  return (
    <div className={'max-w-[22.5rem] bg-[#000624] rounded-4u text-white overflow-hidden'}>
      <div className='flex justify-between overflow-hidden w-full'>
        <div className='py-12u pl-16u space-y-4u overflow-hidden'>
          <span>{title}</span>
          <Paragraph>{description}</Paragraph>
        </div>
        <Button
          className='m-4'
          size={'small'}
          color={'secondary'}
          icon={() => <CloseIconWithoutCircle color={'white'} />}
          onClick={() => {
            onClose();
          }}
        ></Button>
      </div>
      <Button
        size={'small'}
        text={buttonText}
        shape={ButtonShapes.circle}
        textClasses='leading-18 text-14px'
        className={'mt-4u mx-6 mb-4 gap-2!'}
        icon={(iconClasses, color) => <PlayIconUnfilled className={iconClasses} color={color} />}
        onClick={() => {
          dispatch(startUpgradeProcess());
        }}
      />
    </div>
  );
};
